import i18next from '../languages';

const menu = [
  {
    showing: true,
    icon: 'fas fa-box',
    label: "Kasa",
    to: { name: 'adminSafe' },
  },
  {
    showing: true,
    icon: 'fas fa-store',
    label: "Satış Sayfası",
    to: { name: 'sale' }
  },
  {
    showing: true,
    icon: 'fas fa-tasks',
    label: "Ürünler",
    to: { name: 'adminServices' },
    params: { type: 'all' },
  },

  {
    showing: true,
    icon: 'ni ni-book-bookmark',
    label: "Gelir Gider",
    to: { name: 'adminReports' },
  },
  {
    showing: true,
    icon: 'fas fa-warehouse',
    label: "Depo İşlemleri",
    to: { name: 'adminStorage' },
  },
  {
    showing: true,
    icon: 'fas fa-folder-open',
    label: i18next.t('Raporlar'),
    to: { name: 'clients' },
    color: 'primary',
    children: [
      {
        icon: 'ni ni-bullet-list-67',
        label: i18next.t('Ürün Raporları'),
        to: { name: 'satis-raporlari' },
      },
      /*       {
              icon: 'ni ni-bullet-list-67',
              label: i18next.t('Ürün Raporları'),
              to: { name: 'services-reports' },
            },
            {
              icon: 'ni ni-bullet-list-67',
              label: i18next.t('Bayi Raporları'),
              to: { name: 'services-reports' },
            }, */

    ],
  },

  {
    showing: true,
    icon: 'fas fa-cogs',
    label: i18next.t('Ayarlar'),
    to: { name: 'settings' },
  },
];

export default menu;
